import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import { isB2B, isB2C, SpeakUrl } from "../../libs/env";
import { useCustomOrigin } from "../custom_origin/CustomOriginContext";

const WaitModel = ({ 
  data, 
  isOpen,
  toggle,
  message
   
  }) => {
    let customOrigin = useCustomOrigin();
    let text_color = "text-admin";
    if(isB2B.some(domain => customOrigin && customOrigin.includes(domain)))
    {
      text_color = "text-admin";
    }
    else if(isB2C.some(domain => window.location.origin.includes(domain)))
    {
      text_color = "text-purple";
    }
  return (
    <Modal
      isOpen={isOpen}
      size="md"
      toggle={toggle}
      className="modal-dialog-centered"
      backdrop="static"
      data-tc = "wait-modal"
    >
      <ModalBody className="p-0 py-4">
        <h4 className={`${text_color} text-center`}>
            <div>
             <strong>Our AI is grading your work</strong>
            </div>
          <div class={`spinner-border ${text_color} mt-3 fs-5`} role="status">
            <span class="sr-only"></span>
          </div>
        </h4>
        <p className="text-center">
          <strong>
           {message}
            {(isB2C.some((domain) => window.location.origin.includes(domain)) ||
              window.location.pathname.includes(SpeakUrl)) && (
              <p className="pt-1">This process can take up to 60 seconds</p>
            )}
          </strong>
        </p>
      </ModalBody>
    </Modal>
  );
};

WaitModel.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
};

WaitModel.defaultProps = { isOpen: false };

export default WaitModel;
